export const CONFIDENCE_SCORE_THRESHOLD = 1
export const FORCE_DISABLE_AUDIT_TRAIL = true
